export default __webpack_public_path__ + "646c9a53fdcf849109c9f4d9eccf6adb.png";